import { PlugIcon } from '@phosphor-icons/react'
import { match } from 'ts-pattern'
import { SCMIcon } from '../../../components/third-party-branding/scm-icon.tsx'
import { ToolIcon } from '../../../components/third-party-branding/tool-icon.tsx'
import type { Integration } from '../../../utils/api-client/api-schemas.ts'
import { convertIntegrationTypeToTool, getIsScmIntegrationType } from '../../../utils/repository-utils.tsx'
import type { CatalogIcon } from './integration-instance-utils.ts'

type CatalogBrandIconProps = {
  icon: CatalogIcon
}

// Renders the brand glyph for a catalog entry, bridging the three icon sources (SCM provider, Tool,
// or none). Catalog tools without a bundled asset (e.g. Renovate/Sonatype) fall back to a generic
// plug glyph so the grid stays visually consistent.
export const CatalogBrandIcon: React.FC<CatalogBrandIconProps> = ({ icon }) =>
  match(icon)
    .with({ kind: 'scm' }, ({ type }) => <SCMIcon type={type} size="medium+" />)
    .with({ kind: 'tool' }, ({ tool }) => <ToolIcon tool={tool} size="medium+" />)
    .with({ kind: 'none' }, () => <PlugIcon size={24} weight="regular" />)
    .exhaustive()

type IntegrationBrandIconProps = {
  integration: Integration
}

// Renders the brand glyph for a configured instance. Source providers use the SCM glyph; tools use
// the tool glyph (icons are per-tool and shared across a tool's instances).
export const IntegrationBrandIcon: React.FC<IntegrationBrandIconProps> = ({ integration }) =>
  getIsScmIntegrationType(integration.type) ? (
    <SCMIcon type={integration.type} size="medium+" />
  ) : (
    <ToolIcon tool={convertIntegrationTypeToTool(integration.type)} size="medium+" />
  )
